// extracted by mini-css-extract-plugin
export var chevronIcon = "_97-2";
export var teamName = "_97-1";
export var teamSwitcherButton = "_97-0";